import React from "react";

const VideoBarPersonShareOn = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="5" width="16" height="10" rx="2" fill="#FEB700" />
      <path
        d="M4.8418 18.9998C11.5786 17.3907 12.4207 17.3907 19.1576 19"
        stroke="#FEB700"
        strokeWidth="2"
      />
      <path
        d="M12.31 10.7109C9.844 10.5311 7.7425 12.162 7 13C7.666 10.4085 10.8175 8.92944 12.31 8.51387V6L16 9.35182L12.31 12.7036V10.7109Z"
        fill="#023A4A"
      />
    </svg>
  );
};

export default VideoBarPersonShareOn;
